import { useSelector } from 'react-redux'

const ConditionalRender = ({ children, condition, permissions }) => {
  const user = useSelector(state => state.auth.user)

  const hasPermission = () => {
    if (user?.isAdmin) {
      return true
    }

    const hasCondition = typeof condition !== 'undefined'
    const hasPermissions = typeof permissions !== 'undefined'

    if (hasCondition && hasPermissions) {
      const hasPerms = Array.isArray(permissions)
        ? permissions.every(p => user?.permissions?.includes(p))
        : user?.permissions?.includes(permissions)
      return Boolean(condition) && hasPerms
    }

    if (hasCondition) {
      return Boolean(condition)
    }

    if (hasPermissions && Array.isArray(permissions)) {
      return permissions.every(p => user?.permissions?.includes(p))
    }

    if (hasPermissions) {
      return user?.permissions?.includes(permissions)
    }

    return false
  }

  return hasPermission() ? children : null
}

export default ConditionalRender
